import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material"
import Button from "@mui/material/Button"
import * as React from "react"

export const SuccessDialog = ({ message, closeDialog }) => {
  return (
    <>
      <DialogTitle id="alert-success-dialog-title">Success</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-success-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={closeDialog}
          color="primary"
          variant="contained"
          autoFocus
        >
          OK
        </Button>
      </DialogActions>
    </>
  )
}
